import React from 'react';

/**
 * First focusable element on the page, landing on `main`. Visually hidden
 * until focused, then rendered as a solid control clear of the sticky
 * header so it is never obscured.
 */
export function SkipLink() {
  return <a data-component-id="C01" href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-container focus:bg-flame focus:px-4 focus:py-3 focus:text-sm focus:font-bold focus:uppercase focus:tracking-wide focus:text-white focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ink focus:ring-offset-2" data-id="element-464" data-mp="28d3jua26ir9t">
      Skip to main content
    </a>;
}